module.exports = __webpack_public_path__ + "img/adas-hil-1.39a56d56.svg";